module.exports = __webpack_public_path__ + "static/media/externalLink.bc0604a8.svg";